import React from "react";

const year = new Date().getFullYear();
const TimeCard = ({ title, description, link }) => (
  <div className="bg-white p-5 rounded-30 rounded-tl-none relative w-5/6 flex flex-col gap-2">
    <span className="w-[25px] h-[25px] absolute bg-white -left-[34px] -top-[12.5px] rounded-full border-2 border-red-600" />
    <p className="font-bold text-red-500">{title} {year}</p>
    <p>
      {description}
    </p>
    <a
      href={link}
      target="_blank"
      className="p-2 bg-red-500 rounded-full rounded-tl-none self-end w-max text-white hover:bg-[#fbc4ab] hover:text-red-500 font-bold "
    >
      Registrate
    </a>
  </div>
);
const Timeline = () => {
  const fechas = [
    {
      fecha: "Febrero",
      descripcio: "Inicio primer entrenamiento IELTS.",
      link: "https://wa.link/bnt46d",
    },
    {
      fecha: "Junio",
      descripcio: "Primera presentación de la prueba IELTS.",
      link: "https://wa.link/bnt46d",
    },
    {
      fecha: "Agosto",
      descripcio:
        "Inicio segundo entrenamiento IELTS. Registrate entre la 1ra y 2da semana de agosto.",
      link: "https://wa.link/bnt46d",
    },
    {
      fecha: "Octubre - Diciembre",
      descripcio: "Inicio primer entrenamiento IELTS.",
      link: "https://wa.link/bnt46d",
    },
  ];
  
  return (
    <div className="w-1/2 m-10 hyphens-none">
      <div className="flex flex-col border-l-4 border-[#fbc4ab] pl-5 py-5 gap-10">
        {fechas.map((f, i) => (
          <TimeCard key={i} title={f.fecha} description={f.descripcio} link={f.link}/>
        ))}
      </div>
    </div>
  );
};

export default Timeline;
